import { CRM_OBJECT_SUMMARY } from '../../constants/Tools';
import { convertObjectTypeToObjectTypeId, parseObjectId } from '../../utils/parserUtils';
import { getChirpToolOrLegacyTool } from '../utils/chirpToolUtil';
const supportedObjectTypes = ['COMPANY', 'CONTACT', 'DEAL', 'TICKET', 'CALL', 'FEEDBACK_SUBMISSION', 'CAMPAIGN'];

/**
 * Converts a legacy Object Engagements Summary action to a V2 compatible format
 * Maps to CRM Object Summary tool with focus on engagements
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertObjectEngagementsSummaryAction = (inAppActionLegacy, isUngatedForLoadableTools) => {
  const {
    name,
    chirpToolServiceFqcn
  } = getChirpToolOrLegacyTool(CRM_OBJECT_SUMMARY, isUngatedForLoadableTools);
  return {
    name,
    chirpToolServiceFqcn,
    arguments: {
      '@type': 'map',
      value: {
        summaryFormat: {
          '@type': 'string',
          value: 'STANDARD'
        },
        summaryType: {
          '@type': 'string',
          value: 'STANDARD'
        },
        propertiesToInclude: {
          '@type': 'list',
          value: []
        },
        query: inAppActionLegacy.text ? {
          '@type': 'string',
          value: inAppActionLegacy.text
        } : undefined,
        objectCoordinates: {
          '@type': 'map',
          value: {
            objectId: {
              '@type': 'long',
              value: Number(parseObjectId(inAppActionLegacy.objectId))
            },
            objectTypeId: {
              '@type': 'map',
              value: {
                innerId: {
                  '@type': 'integer',
                  value: supportedObjectTypes.includes(inAppActionLegacy.objectType) ? Number(convertObjectTypeToObjectTypeId(inAppActionLegacy.objectType).split('-')[1]) : Number(inAppActionLegacy.objectType.split('-')[1])
                },
                metaType: {
                  '@type': 'string',
                  value: 'HUBSPOT'
                }
              }
            }
          }
        }
      }
    }
  };
};